<!-- ACTION BUTTONS FOR MOBILE -->
<div class="grid mt-0">
	<div [class]="colResponsive('left')">
		<div *ngFor="let exceptionList of exceptionsList">
			<div class="my-2 ml-1 font-medium">{{ exceptionList.Date | localizedDate: 'MMMM yyyy' }}</div>
			<div *ngIf="exceptionList.ListException.length > 0">
				<p-chip *ngFor="let exception of exceptionList.ListException"
					label="{{ exception.DateMom | localizedDate: 'mediumDate' }}" [removable]="edit"
					(onRemove)="updateCalendar(exception)" styleClass="p-chip-datexclusion" class="mr-2">
				</p-chip>
			</div>
		</div>
	</div>
	<div [class]="colResponsive('right')">
		<p-calendar class="flex align-content-center justify-content-center flex-wrap w-full" [formControl]="dateForm"
			panelStyleClass="p-datepicker p-datepicker-danger" [inline]="true" selectionMode="multiple"
			inputId="multipleDates" [defaultDate]="minDate">
		</p-calendar>
	</div>
</div>